import { PageHeader } from "@/components/common/Reveal";
import { CONTACT } from "@/data/site";

const SECTIONS = [
  ["Who we are", "Ramor Renewables Heating & Plumbing Ltd, Virginia Shopping Centre, Unit 1A, Block A, Virginia, Co. Cavan, A82 X9W4, is the controller of personal data collected through this website. [Placeholder — replace with your registered company details.]"],
  ["What we collect", "When you send a project enquiry we collect your name, company, email, phone number and the project details you provide. When you apply for a role we collect your name, phone, email, the role, your years of experience, whether you hold Safe Pass / Manual Handling certification and any message you include."],
  ["Why we use it", "We use this information only to respond to your enquiry or application and to manage any resulting project or recruitment process. [Placeholder — confirm your lawful basis for processing.]"],
  ["How long we keep it", "[Placeholder — state your retention period for enquiries and job applications.]"],
  ["Sharing", "We do not sell your personal data. It is shared only with service providers who help us run this website and deliver email, under appropriate safeguards. [Placeholder — list any processors.]"],
  ["Your rights", `You may ask to access, correct or delete your personal data, or object to its use, by emailing ${CONTACT.enquiriesEmail}. You also have the right to complain to the Data Protection Commission (dataprotection.ie).`],
];

export default function Privacy() {
  return (
    <main data-testid="privacy-page">
      <PageHeader testid="privacy-header" label="Legal" title="Privacy notice" text="How we handle the information you share with us through this website." />
      <section className="mx-auto max-w-3xl px-5 py-16 sm:px-8 sm:py-24">
        {SECTIONS.map(([t, body], i) => (
          <div key={t} className="border-t border-canvas-line py-8">
            <p className="label-mono text-brand">§ {String(i + 1).padStart(2, "0")}</p>
            <h2 className="mt-3 font-display text-3xl font-bold uppercase">{t}</h2>
            <p className="mt-4 leading-relaxed text-steel">{body}</p>
          </div>
        ))}
      </section>
    </main>
  );
}
